import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {  Formik, Form, Field } from 'formik';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; 
import { parseISO, parse, isValid, startOfDay } from 'date-fns';
import classNames from "classnames";
import {LinearProgress,Box, Fab, Modal, Fade, TextField, Backdrop, Typography, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, 
  Stepper, Step, StepLabel, List, ListItem, ListItemText, Divider, MenuItem} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Support from '../../components/support/Support';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import GridItem from "../../components/Grid/GridItem.jsx";
import Skeleton from "@mui/material/Skeleton"
import GridContainer from "../../components/Grid/GridContainer.jsx";
import { useTheme } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import { mongoUrl } from '../../components/shared/mongoUrl';
import { baseUrl } from '../../components/shared/baseUrl';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators.js";
import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "../../components/assets/jss/material-dashboard-react.js";




export const styles = (theme) =>({
   cardTitle: {
        color: 'blue',
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
          color: grayColor[1],
          fontWeight: "400",
          lineHeight: "1"
        }
      },
     cardCategory: {
        color: grayColor[0],
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
      },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
  },
  fontPapyrus:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  fontMonaco:{
    fontFamily:"'Monaco','monospace'"
  },
  fontCursive: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  fontBrush: {
    fontFamily:"'Brush Script MT', 'Cursive'"
  },
  fontGaramond: {
    fontFamily:"'Garamond', 'Serif'"
  },
  fontCourier:{
    fontFamily:"'Courier New', 'monospace'"
  },
  fontLucida:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  deco:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  abs:{
    fontFamily:"'Monaco','monospace'"
  },
  algo: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  pat:{
    fontFamily:"'Courier New', 'monospace'"
  },
  ana:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontFamily:"'Lucida Handwriting', 'Brush Script MT'"
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    fontFamily:"'Lucida Console', 'monospace'"
  },
  modal: {
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
  },
  modal1:{
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  modal2:{
    position: 'relative',
    maxWidth: '500px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '40vh',
    overflowY: 'auto'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
  }
});

var numberList = [
  { label: '', value: ''},{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
  , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
  , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
  , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
  , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
  , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
  , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
  , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
  , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 54}, { label: 75, value: 75}
  , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
  , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
  , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
  , { label: 91, value: 91}, { label: 92, value: 92}, { label: 93, value: 93}, { label: 94, value: 94}, { label: 95, value: 95}
  , { label: 96, value: 96}, { label: 97, value: 97}, { label: 98, value: 98}, { label: 99, value: 99}, { label: 100, value: 100}
];

var numberNewList = [
  { label: '', value: ''},{ label: 'n', value: 'n' },{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
  { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
  , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
];

var bracketList = [
  { label: '(', value: '(' },
  { label: ')', value: ')'}
];

var pairList = [
  { label: 'Pairwise sum=', value: 'Pairwise sum=' },
  { label: 'Pair count=', value: 'Pair count='}
];
var nVarList = [
  {label: 'n', value: 'n'},
  {label: '', value: ''}
]

var answerList = [
  {label: 'Strongly disagree', value: 'Strongly disagree'},
  {label: 'Disagree', value: 'Disagree'},
  {label: 'Neutral', value: 'Neutral'}, 
  {label: 'Agree', value: 'Agree'},
  {label: 'Strongly agree', value: 'Strongly agree'}
]

var compareList = [
  { label: '=', value: '=' },
  { label: '==', value: '==' },
  { label: '!=', value: '!=' },
  { label: '>', value: '>' },
  { label: '>=', value: '>=' },
  { label: '<', value: '<' },
  { label: '<=', value: '<=' }
]

var operatorList = [
  { label: '+', value: '+' },
  { label: '-', value: '-'},
  { label: '*', value: '*'},
  { label: '/', value: '/'},
  { label: '', value: ''}
];

var termList = [
  { label: '... upto 60 terms', value: '... upto 60 terms' },
  { label: '... upto 30 terms', value: '... upto 30 terms'},
  { label: '', value: ''}
];

var alternateList = [
  { label: 'Individual addition', value: 'Individual addition' },
  { label: 'Pairwise addition', value: 'Pairwise addition'}
];

var task = ['Below enter the details in user information questionnaire', 'Read each question and select one answer out of the options',
 'Read each statement and provide answers accorfingly']


function getSteps() {
  return ['User information', 'Computational Thinking Test', 'Self efficacy'];
}

const hintsActivity1 = [
  { step: 'User information'},
  { step: 'Computational Thinking Test'},
  { step: 'Self efficacy' }
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};

var cla = {
  "_id":"6006f33eef2c0d65ccbf6601",
  "title": "Class IX",
  "teacherId":"5fe192d970d8c633c005da24"
}


export default function Hypothesis(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [myCount, setmyCount] = React.useState(10);
    const [isSubmit, setisSubmit] = React.useState(false);
    const [finalCount, setfinalCount] = React.useState(19);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes =styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState('panel1');
    const [gender, setgender] = React.useState('male');
    const [implement, setimplement] = React.useState('No'); 
    const [que, setque] = React.useState('');
    const [que1, setque1] = React.useState('');
    const [que2, setque2] = React.useState('IX');
    const [que3, setque3] = React.useState('');
    const [que4, setque4] = React.useState('');
    const [que5, setque5] = React.useState('');
    const [que6, setque6] = React.useState('');
    const [que7, setque7] = React.useState('');
    const [que8, setque8] = React.useState('');
    const [que9, setque9] = React.useState('');
    const [que10, setque10] = React.useState('');
    const [que11, setque11] = React.useState('');
    const [que12, setque12] = React.useState('');
    const [que13, setque13] = React.useState('');
    const [que14, setque14] = React.useState('');
    const [que15, setque15] = React.useState('');
    const [que16, setque16] = React.useState('');
    const [que17, setque17] = React.useState('');
    const [que18, setque18] = React.useState('');
    const [que19, setque19] = React.useState('');
    const [que20, setque20] = React.useState(''); 
    const [que21, setque21] = React.useState('');   
    const [que22, setque22] = React.useState('');   
    const [que23, setque23] = React.useState('');   
    const [que24, setque24] = React.useState('');   
    const [que25, setque25] = React.useState('');   
    const [que26, setque26] = React.useState('');   
    const [que27, setque27] = React.useState('');   
    const [que28, setque28] = React.useState('');   
    const [que29, setque29] = React.useState('');   
    const [que30, setque30] = React.useState('');   
    const [que31, setque31] = React.useState('');   
    const [que32, setque32] = React.useState('');   
    const [que33, setque33] = React.useState('');   
    const [que34, setque34] = React.useState('');   
    const [que35, setque35] = React.useState('');   
    const [que36, setque36] = React.useState('');   
    const [que37, setque37] = React.useState('');   
    const [que38, setque38] = React.useState('');   
    const [que39, setque39] = React.useState('');   
    const [que40, setque40] = React.useState('');   
    
    const [mydata, setmydata] = React.useState('');
    const [self1, setself1] = React.useState('');
    const [self2, setself2] = React.useState('');
    const [self3, setself3] = React.useState('');
    const [self4, setself4] = React.useState('');
    const [self5, setself5] = React.useState('');
    const [self6, setself6] = React.useState('');
    const [self7, setself7] = React.useState('');
    const [self8, setself8] = React.useState('');
    const [self9, setself9] = React.useState('');
    const [self10, setself10] = React.useState('');
    const [self11, setself11] = React.useState('');
    const [self12, setself12] = React.useState('');
    const [self13, setself13] = React.useState('');
    const [self14, setself14] = React.useState('');
    const [self15, setself15] = React.useState('');
    const [self16, setself16] = React.useState('');
    const [self17, setself17] = React.useState('');
    const [self18, setself18] = React.useState('');
    const [patnum2, setpatnum2] = React.useState('');
    const [patnum3, setpatnum3] = React.useState('');
    const [patnum4, setpatnum4] = React.useState('');
    const [patnum5, setpatnum5] = React.useState('');
    const [patnum6, setpatnum6] = React.useState('');
    const [patnum7, setpatnum7] = React.useState('');
    const [patnum8, setpatnum8] = React.useState('');
    const [mypattern, setmypattern] = React.useState('');
    const [mypattern1, setmypattern1] = React.useState('');
    const [abs1, setabs1] = React.useState('');
    const [abs2, setabs2] = React.useState('');
    const [abs3, setabs3] = React.useState('');
    const [abs4, setabs4] = React.useState('');
    const [abs5, setabs5] = React.useState('');
    const [abs6, setabs6] = React.useState('');
    const [abs7, setabs7] = React.useState('');
    const [absNum, setabsNum] = React.useState('60');
    const [algo1, setalgo1] = React.useState('');
    const [algo2, setalgo2] = React.useState('');
    const [algo3, setalgo3] = React.useState('');
    const [algo4, setalgo4] = React.useState('');
    const [myalgo, setmyalgo] = React.useState('');
    const [myalgo1, setmyalgo1] = React.useState('');
    const [myalgo2, setmyalgo2] = React.useState('');
    const [myalgo3, setmyalgo3] = React.useState('');
    const [myalgo4, setmyalgo4] = React.useState('');
    const [myalgo5, setmyalgo5] = React.useState('');
    const [mybutton, setbutton] = React.useState('false');
    const [mytime, setmytime] = React.useState('');
    const [myspace, setmyspace] = React.useState('');
    const [mycomsol, setmycomsol] = React.useState('');
    const [mycomsol1, setmycomsol1] = React.useState('');
    const [mycomsol2, setmycomsol2] = React.useState('');
    const [mycomsol3, setmycomsol3] = React.useState('');
    const [sollist, setsollist] = React.useState([]);
    const [wait, setwait] = React.useState(false);
    const [openBoard, setopenBoard] = React.useState(false);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(false);
    const [myModalTwo, setmyModalTwo] = React.useState(true);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [altHint, setaltHint] = React.useState('');
    const [totaldata, settotaldata] = React.useState('')
    //const classes1 = styles1(theme)
    const [selectedDate, handleDateChange] = React.useState(new Date());
    const { classId, sesId } = useParams();


 

    useEffect(() => {
        const dateFromAPI = "2024-06-01"; // simulate string from API
        handleDateChange(parseISO(dateFromAPI))
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          setclas(cla)            
          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((resp) =>{
            settotaldata(resp.data)        
            const activity = resp.data.activity1[0]
              setmydata(activity)
              if(resp.data.preTest[0].initial!==""){
              var arr  = resp.data.preTest[0].initial.split(',')
                setque1(arr[0])
                console.log(arr[1])
                const parsedDate = new Date(arr[1]);
                if (isValid(parsedDate)) {
                  handleDateChange(parsedDate);
                } else {
                  console.error("Invalid API date:", arr[1]);
                  handleDateChange(null);
                }
                setgender(arr[2])
                setque2(arr[3])
                setque(arr[4])
                setimplement(arr[5])
                setque3(arr[6])
                setque4(arr[7])
                setque5(arr[8])      
            }
            if(resp.data.preTest[0].bebras!==''){
              console.log(resp.data.preTest[0].bebras)
              var arr = resp.data.preTest[0].bebras.split(',')
              //console.log(arr.length)
                setque6(arr[0])
                setque7(arr[1])
                setque8(arr[2])
                setque9(arr[3])
                setque10(arr[4])
                setque11(arr[5])
                setque12(arr[6])
                setque13(arr[7])
                setque14(arr[8])
                setque15(arr[9])
                setque16(arr[10])
                setque17(arr[11])
                setque18(arr[12])
                setque19(arr[13])
                setque20(arr[14])
                setque21(arr[15])
                setque22(arr[16])
                setque23(arr[17])
                setque24(arr[18])
                setque25(arr[19])
                setque26(arr[20])
                setque27(arr[21])
                setque28(arr[22])
                setque29(arr[23])
                setque30(arr[24])
                setque31(arr[25])
                setque32(arr[26])
                setque33(arr[27])
                setque34(arr[28])
                setque35(arr[29])
                setque36(arr[30])
            }


            getData(sessid);
            
            setloading(false)
            
          
          })
          .catch((error)=>{
            console.log(error);
            });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })



 

  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
     const imageVariants = {
      animateOne:{
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  repeat: finalCount,
                  duration:3,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      },
      animateTwo:{
        x: [0, 499],
        //y: [0, -30],
        transition: {
            x:{
                repeat: finalCount,
                duration:3,
                ease:"easeOut"
            },
            // y:{
            //     yoyo: Infinity,
            //     duration:0.25,
            //     ease:"easeOut"
            // },
        }
      }
    }

  

    


    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    
    const closeModalYesThree=()=>{
      
      var answerCorrect=false
      
      setmyModalThree(!myModalThree)
     
      
      if(activeStep==0){
        var err=true
        if(error==''){
          err=false
        }
        if(err===false){

          var ans = que1+','+selectedDate+','+gender+','+que2+','+que+','+implement+','+que3+','+que4+','+que5

          console.log(ans)
          seterror('')
          totaldata.preTest[0].initial=ans
             
        const data=
        {
          preTest: totaldata.preTest
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity1[0]
          setmydata(activity)
          settotaldata(response.data)                    
          
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          console.log('Going to'+activeStep) 
          setansType("Great work!! Let's move to next")

          setisSubmit(false)
          setmyModalTwo(!myModalTwo)    ////code for hints modal
          seterror('')

      })
      }
      else {
        setisSubmit(false)
      }     

      }

      if(activeStep==1){
        var err=true
        if(error==''){
          err=false
        }
        if(err===false){

          var ans = que6+','+que7+','+que8+','+que9+','+que10+','+que11+','+que12+','+que13+','+que14+','+que15+','+que16+','+que17+','+que18+','+que19+','+que20+
          ','+que21+','+que22+','+que23+','+que24+','+que25+','+que26+','+que27+','+que28+','+que29+','+que30+
          ','+que31+','+que32+','+que33+','+que34+','+que35+','+que36
          
          var score=0;
          ///que1
          if(que6==='Option2'){
            score = score+2
          }
          if(que7=='Option1'){
            score = score+2
          }
          if(que8=='Option3'){
            score = score+2
          }///que2
          if(que9=='Option1'){
            score = score+1.5
          }
          if(que10=='Option2'){
            score = score+1.5
          }
          if(que11=='Option3'){
            score = score+1.5
          }
          if(que12=='Option1'){
            score = score+1.5
          }///que3
          if(que13==='Option1'){
            score = score+2
          }
          if(que14=='Option4'){
            score = score+2
          }
          if(que15=='Option1'){
            score = score+2
          }///que4
          if(que16==='Option3'){
            score = score+3
          }
          if(que17=='Option2'){
            score = score+3
          }
          ///que5
          if(que18==='Option2'){
            score = score+4.5
          }
          if(que19=='Option1'){
            score = score+4.5
          }///que6
          if(que20==='Option1'){
            score = score+3
          }
          if(que21=='Option1'){
            score = score+3
          }
          if(que22=='Option4'){
            score = score+3
          }///que7
          if(que23==='Option2'){
            score = score+3
          }
          if(que24=='Option1'){
            score = score+3
          }
          if(que25=='Option4'){
            score = score+3
          }///que8
          if(que26==='Option1'){
            score = score+4.5
          }
          if(que27=='Option3'){
            score = score+4.5
          }///que9
          if(que28==='Option1'){
            score = score+12
          }///que10
          if(que29==='Option2'){
            score = score+6
          }
          if(que30=='Option2'){
            score = score+6
          }///que11
          if(que31=='Option1'){
            score = score+3
          }
          if(que32=='Option1'){
            score = score+3
          }
          if(que33=='Option3'){
            score = score+3
          }
          if(que34=='Option3'){
            score = score+3
          }///que12
          if(que35==='Option3'){
            score = score+6
          }
          if(que36=='Option3'){
            score = score+6
          }

          console.log('score '+score)
          console.log(ans)
          seterror('')
          totaldata.preTest[0].bebras=ans+','+score
             
        const data=
        {
          preTest: totaldata.preTest
        }
                  
  
      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
      .then((response) => {

        var nam = totaldata.preTest[0].initial.split(',')
        var newscore = score*100/108

        var problemtype = 'medium'
      if(parseInt(newscore)<40){
        problemtype='easy'
      }
      else if(parseInt(newscore)>75){
        problemtype='hard'
      }
      response.data.userName=nam[0]
      response.data.activity1[0].profileScore=newscore
      response.data.activity1[0].level=problemtype
        // const data=
        //   {
        //     act: 'activity1',
        //     data: response.data.activity1[0]
        //   }   
          const data=
          {
            profile: response.data
          }                    
          console.log(data)
      
          axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
          .then((response) => {
              console.log(response.data)
              const activity = response.data.activity1[0]
            
              setmydata(activity) 
              settotaldata(response.data)  

              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")

              setisSubmit(false)
              setmyModalTwo(!myModalTwo) ////code for hints modal
              seterror('')
          })
      })
      }
      else{
        setisSubmit(false)
      }

      }

      if(activeStep==2){
        
      console.log(isSubmit)
      var err=true
      if(error==''){
        err=false
       }
        if(err===false){
          var ans = self1+','+self2+','+self3+','+self4+','+self5+','+self6+','+self7+','+self8+','+self9+','+self10+
          ','+self11+','+self12+','+self13+','+self14+','+self15+','+self16+','+self17+','+self18
    
          console.log(ans)
          seterror('')
          totaldata.preTest[0].efficacy=ans
          totaldata.preTest[0].completed=true
             
        const data=
        {
          preTest: totaldata.preTest
        }                                                
  
      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity1[0]
          setmydata(activity)
          settotaldata(response.data)  

          history(`/student/dashboard/viewstudentclass/${clas._id}/session/${response.data.sessionId}/profile/${response.data._id}/scenario`)

          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')
        })

      }
      else{
        setisSubmit(false)
        seterror('Please enter text/number/operators in above space')
      }

    }      
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)
      setisSubmit(false)
    }

    


    // console.log(mydata.decomposition)

    function getStepContent(step) {
      switch (step) {
        case 0:
          return 'User information' ;
        case 1:
          return 'Computational Thinking Test';
        case 2:
          return 'self efficacy';
      }
    }

    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity1[0]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity)
           
  
      })
    
  }

  const movedat = (sou,dest,typ) =>{

    var dat = {
      source:sou,
      destination:dest,
      altStep:mydata.altStep,
      type:typ,
  
    }
    const data=
    {
      act:'activity1',
      moveData:dat
    }                     
    console.log(data)
  
  //   axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
  //   .then((response) => {
  //     console.log(response.data)
  //     const activity = response.data.activity1[0]
  //     setmydata(activity)
  // })
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false;

    if(activeStep==0 && totaldata.preTest[0].bebras!==''){
      
      console.log('Going next Completed initial form')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo(0, 0)
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
          if(totaldata.preTest[0].bebras!==''){
            console.log(totaldata.preTest[0].bebras)
            var arr = totaldata.preTest[0].bebras.split(',')
            //console.log(arr.length)
              setque6(arr[0])
              setque7(arr[1])
              setque8(arr[2])
              setque9(arr[3])
              setque10(arr[4])
              setque11(arr[5])
              setque12(arr[6])
              setque13(arr[7])
              setque14(arr[8])
              setque15(arr[9])
              setque16(arr[10])
              setque17(arr[11])
              setque18(arr[12])
              setque19(arr[13])
              setque20(arr[14])
              setque21(arr[15])
              setque22(arr[16])
              setque23(arr[17])
              setque24(arr[18])
              setque25(arr[19])
              setque26(arr[20])
              setque27(arr[21])
              setque28(arr[22])
              setque29(arr[23])
              setque30(arr[24])
              setque31(arr[25])
              setque32(arr[26])
              setque33(arr[27])
              setque34(arr[28])
              setque35(arr[29])
              setque36(arr[30])
              
          }
            
      comp=true;
    }
    else if(activeStep==1 && totaldata.preTest[0].efficacy!==''){
      console.log('Going next Completed bebras')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      
      if(totaldata.preTest[0].efficacy!==''){
        console.log(totaldata.preTest[0].efficacy)
        var arr = totaldata.preTest[0].efficacy.split(',')
        //console.log(arr.length)
          setself1(arr[0])
          setself2(arr[1])
          setself3(arr[2])
          setself4(arr[3])
          setself5(arr[4])
          setself6(arr[5])
          setself7(arr[6])
          setself8(arr[7])
          setself9(arr[8])
          setself10(arr[9])
          setself11(arr[10])
          setself12(arr[11])
          setself13(arr[12])
          setself14(arr[13])
          setself15(arr[14])
          setself16(arr[15])
          setself17(arr[16])
          setself18(arr[17]) 
      }

      comp=true;

    }
    else if(activeStep==2 && totaldata.preTest[0].completed===true){
      
      history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/profile/${totaldata._id}/scenario`)

      comp=true
      
    }
    
    console.log(activeStep)

   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
   }
   else{
     movedat(getStepContent(activeStep),getStepContent(activeStep+1),'completed')
   }  

  };

  const handleBack = () => {
    movedat(getStepContent(activeStep),getStepContent(activeStep-1),'completed')
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    console.log('Going Back to '+activeStep)
    console.log(mydata)
////Code to update the text area when click back
    if(activeStep-1==0){
      
    }
    else if(activeStep-1==1){
      
    }
    else if(activeStep-1==2){
          
    }
    else if(activeStep-1==3){
    
    }
    else if(activeStep-1==4){
      
    }

  };

  const commaToText = (txt) =>{
    var mytext = ''
    if(txt!='' && typeof(txt)!=='undefined'){ 
    if(txt.includes(',')==true){
      var newArr = txt.split(',')
      var i=0
      while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
            mytext=mytext+' '+newArr[i]
            i=i+1
        }  
      
       return mytext
    }
    else{
      return txt
    }
  }
  return txt
    
 }

  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleClosePreview= () => {
        setopenBoard(!openBoard)
      }

      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }
   
    const handleQueChange =(event)=> {
      setque(event.target.value)
    }
    const handleQue1Change =(event)=> {
      setque1(event.target.value)
    }
    const handleQue2Change =(event)=> {
      setque2(event.target.value)
    }
    const handleQue3Change =(event)=> {
      setque3(event.target.value)
    }
    const handleQue4Change =(event)=> {
      setque4(event.target.value)
    }
    const handleQue5Change =(event)=> {
      setque5(event.target.value)
    }
    const handleQue6Change =(event)=> {
      setque6(event.target.value)
    }
    const handleQue7Change =(event)=> {
      setque7(event.target.value)
    }
    const handleQue8Change =(event)=> {
      setque8(event.target.value)
    }
    const handleQue9Change =(event)=> {
      setque9(event.target.value)
    }
    const handleQue10Change =(event)=> {
      setque10(event.target.value)
    }
    const handleQue11Change =(event)=> {
      setque11(event.target.value)
    }
    const handleQue12Change =(event)=> {
      setque12(event.target.value)
    }
    const handleQue13Change =(event)=> {
      setque13(event.target.value)
    }
    const handleQue14Change =(event)=> {
      setque14(event.target.value)
    }
    const handleQue15Change =(event)=> {
      setque15(event.target.value)
    }
    const handleQue16Change =(event)=> {
      setque16(event.target.value)
    }
    const handleQue17Change =(event)=> {
      setque17(event.target.value)
    }
    const handleQue18Change =(event)=> {
      setque18(event.target.value)
    }
    const handleQue19Change =(event)=> {
      setque19(event.target.value)
    }
    
    const handleSelf1Change =(event)=> {
      setself1(event.target.value)
    }
    const handleSelf2Change =(event)=> {
      setself2(event.target.value)
    }
    const handleSelf3Change =(event)=> {
      setself3(event.target.value)
    }
    const handleSelf4Change =(event)=> {
      setself4(event.target.value)
    }
    const handleSelf5Change =(event)=> {
      setself5(event.target.value)
    }
    const handleSelf6Change =(event)=> {
      setself6(event.target.value)
    }
    const handleSelf7Change =(event)=> {
      setself7(event.target.value)
    }
    const handleSelf8Change =(event)=> {
      setself8(event.target.value)
    }
    const handleSelf9Change =(event)=> {
      setself9(event.target.value)
    }
    const handleSelf10Change =(event)=> {
      setself10(event.target.value)
    }
    const handleSelf11Change =(event)=> {
      setself11(event.target.value)
    }
    const handleSelf12Change =(event)=> {
      setself12(event.target.value)
    }
    const handleSelf13Change =(event)=> {
      setself13(event.target.value)
    }
    const handleSelf14Change =(event)=> {
      setself14(event.target.value)
    }
    const handleSelf15Change =(event)=> {
      setself15(event.target.value)
    }
    const handleSelf16Change =(event)=> {
      setself16(event.target.value)
    }
    const handleSelf17Change =(event)=> {
      setself17(event.target.value)
    }
    const handleSelf18Change =(event)=> {
      setself18(event.target.value)
    }
    
    
      
   
      const CalculateOddSum=()=>{
        var code=''
        if(absNum!=='' && typeof(absNum)!='undefined'){
            code=`n=${absNum}; return n`
        }    
        if(absNum!=='' && typeof(absNum)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs2)!='undefined' && typeof(abs3)!='undefined'){
            code=`n=${absNum}; sum = (${abs1}${abs2}${abs3}); return sum`
        }
        if(absNum!=='' && typeof(absNum)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs3)!='undefined' && typeof(abs2)!='undefined'){
            code=`n=${absNum};sum=(${abs1}${abs2}${abs3})${abs4}(${abs5}); return sum`
        }
        if(absNum!=='' && typeof(absNum)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!='' && abs3!='' && typeof(abs3)!='undefined' && typeof(abs2)!='undefined'){
          code=`n=${absNum};sum=(${abs1}${abs2}${abs3})${abs4}(${abs5}${abs6}${abs7}); return sum`
      }
        const F = new Function(code);  
        var out = F()
        return out
    }

      const InitialForm = () => {
        var err='';
        var mycode=''
        if(que1===''){
          err='Please enter your name'
        }
        else if(gender===''){
          err='Please select a gender'
        }
        else if(que2===''){
          err='Please select class'
        }
        else if(que===''){
          err='Please select section'
        }
        else if(implement===''){
          err='Please enter whether you have implement programming problem previously'
        }
        else if(que3===''){
          err='Please enter if you know any programming language'
        }
        else if(que4===''){
          err='please enter last mathematics score'
        }
        else if(que5===''){
          err='please enter second last mathematics score'
        }
        else{
          var bday = new Date(selectedDate)
          var currdate = new Date()
          var diffTime = Math.abs(currdate - bday);
          var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));           
          console.log(diffDays + " days");
          if(diffDays<2900){
            err='please enter correct d.o.b. Are you sure you are eligible for the test?'
          }
        }
        seterror(err)
      }
      
      const BebrasForm = () => {
        var err='';
        
        if(que6===''|| que7===''|| que8===''){
          err='Please complete all subquestions in question1'
        }
        else if(que9===''|| que10===''|| que11===''|| que12===''){
          err='Please complete all subquestions in question2'
        }
        else if(que13===''|| que14===''|| que15===''){
          err='Please complete all subquestions in question3'
        }
        else if(que16===''|| que17===''){
          err='Please complete all subquestions in question4'
        }
        else if(que18===''|| que19===''){
          err='Please complete all subquestions in question5'
        }
        else if(que20===''|| que21===''|| que22===''){
          err='Please complete all subquestions in question6'
        }
        else if(que23===''|| que24===''|| que25===''){
          err='Please complete all subquestions in question7'
        }
        else if(que26===''|| que27===''){
          err='Please complete all subquestions in question8'
        }
        else if(que28===''){
          err='Please complete all subquestions in question9'
        }
        else if(que29===''|| que30===''){
          err='Please complete all subquestions in question10'
        }
        else if(que31===''|| que32===''|| que33===''|| que34===''){
          err='Please complete all subquestions in question11'
        }
        else if(que35==='' || que36===''){
          err='Please complete all subquestions in question12'
        }
        
        seterror(err)
      }
      
     
      const EfficacyForm = () => {
        var err='';
        
        if(self1===''){
          err='Please complete question1'
        }
        else if(self2===''){
          err='Please complete question2'
        }
        else if(self3===''){
          err='Please complete question3'
        }
        else if(self4===''){
          err='Please complete question4'
        }
        else if(self5===''){
          err='Please complete question5'
        }
        else if(self6===''){
          err='Please complete question6'
        }
        else if(self7===''){
          err='Please complete question7'
        }
        else if(self8===''){
          err='Please complete question8'
        }
        else if(self9===''){
          err='Please complete question9'
        }
        else if(self10===''){
          err='Please complete question10'
        }
        else if(self11===''){
          err='Please complete question11'
        }
        else if(self12===''){
          err='Please complete question12'
        }
        else if(self13===''){
          err='Please complete question13'
        }
        else if(self14===''){
          err='Please complete question14'
        }
        else if(self15===''){
          err='Please complete question15'
        }
        else if(self16===''){
          err='Please complete question16'
        }
        else if(self17===''){
          err='Please complete question17'
        }
        else if(self18===''){
          err='Please complete question18'
        }
        
        seterror(err)
      }


      const handleAlgorithmChange =( event )=> {
        setmyalgo(event.target.value)
      }

      const handleAlgorithmChange1 =( event )=> {
        setmyalgo1(event.target.value)
      }

      const handleAlgorithmChange2 =( event )=> {
        setmyalgo2(event.target.value)
      }

      const handleAlgorithmChange3 =( event )=> {
        setmyalgo3(event.target.value)
      }
      
      const handleAlgorithmChange4 =( event )=> {
        setmyalgo4(event.target.value)
      }

      const handleAlgorithmChange5 =( event )=> {
        setmyalgo5(event.target.value)
      }
      const compareSolutionChange =( event )=> {
        setmycomsol(event.target.value)
      }
      const compareSolutionChange1 =( event )=> {
        setmycomsol1(event.target.value)
      }
      const compareSolutionChange2 =( event )=> {
        setmycomsol2(event.target.value)
      }
      const compareSolutionChange3 =( event )=> {
        setmycomsol3(event.target.value)
      }

      const handleSpaceChange =( event )=> {
        setmyspace(event.target.value)
      }

      const handleTimeChange =( event )=> {
        setmytime(event.target.value)
      }

      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        // toolbar: {
        //   items: [
        //     'heading',
        //     '|',
        //     'bold',
        //     'italic',
        //     'link',
        //     'bulletedList',
        //     'numberedList',
        //     '|',
        //     'blockQuote',
        //     'insertTable',
        //     '|',
        //     'imageUpload',
        //     'undo',
        //     'MathType',
        //     'SpecialCharacters',
        //     'SpecialCharactersMathematical',
        //     'redo',
        //     'Subscript', 
        //     'Superscript',            
        //   ]
        // }
        // ,
        // table: {
        //   contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        // }
      }

      const buttonSelect = (k,que) =>{
        var mysol='Option'+k
        console.log(k)
        console.log(que)
        console.log(que6)
        if(que==6){
            console.log('Matched')
          setque6(mysol)
        }
        else if(que==7){
            setque7(mysol)
        }
        else if(que==8){
            setque8(mysol)
        }
        else if(que==9){
            setque9(mysol)
        }
        else if(que==10){
            setque10(mysol)
        }
        else if(que==11){
            setque11(mysol)
        }
        else if(que==12){
            setque12(mysol)
        }
        else if(que==13){
            setque13(mysol)
        }
        else if(que==14){
            setque14(mysol)
        }
        else if(que==15){
            setque15(mysol)
        }
        else if(que==16){
            setque16(mysol)
        }
        else if(que==17){
            setque17(mysol)
        }
        else if(que==18){
            setque18(mysol)
        }
        else if(que==19){
            setque19(mysol)
        }
        else if(que==20){
            setque20(mysol)
        }
        else if(que==21){
            setque21(mysol)
        }
        else if(que==22){
            setque22(mysol)
        }
        else if(que==23){
            setque23(mysol)
        }
        else if(que==24){
            setque24(mysol)
        }
        else if(que==25){
            setque25(mysol)
        }
        else if(que==26){
            setque26(mysol)
        }
        else if(que==27){
            setque27(mysol)
        }
        else if(que==28){
            setque28(mysol)
        }
        else if(que==29){
            setque29(mysol)
        }
        else if(que==30){
            setque30(mysol)
        }
        else if(que==31){
            setque31(mysol)
        }
        else if(que==32){
            setque32(mysol)
        }
        else if(que==33){
            setque33(mysol)
        }
        else if(que==34){
            setque34(mysol)
        }
        else if(que==35){
            setque35(mysol)
        }
        else if(que==36){
            setque36(mysol)
        }
        else if(que==37){
            setque37(mysol)
        }

      }

      const MCQAnswers =(type, quenum, stat, option1, option2, option3, option4)=>{

        console.log(stat['que'+quenum])
         console.log(quenum) 
         if(type=='row'){   
          return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                
                        <Card hoverable onClick={() => buttonSelect(1,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option1 </b>
                        <CardBody>
                            <b style={classes.ana}> {option1} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                
                        <Card hoverable onClick={() => buttonSelect(2,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option2 </b>
                        <CardBody>
                            <b style={classes.ana}> {option2} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                
                        <Card hoverable onClick={() => buttonSelect(3,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option3 </b>
                        <CardBody>
                            <b style={classes.ana}> {option3} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                
                        <Card hoverable onClick={() => buttonSelect(4,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                            <b align="center"> Click to select option4 </b>
                        <CardBody>
                            <b style={classes.ana}> {option4} </b>
                        </CardBody>
                        </Card>
                    </Link>
                </GridItem>
            </GridContainer>               
            );
          }
          else if(type=='col'){   
            return (
              <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                  
                          <Card hoverable onClick={() => buttonSelect(1,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option1 </b>
                          <CardBody>
                              <b style={classes.ana}> {option1} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(2,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option2 </b>
                          <CardBody>
                              <b style={classes.ana}> {option2} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(3,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option3 </b>
                          <CardBody>
                              <b style={classes.ana}> {option3} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(4,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option4 </b>
                          <CardBody>
                              <b style={classes.ana}> {option4} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
              </GridContainer>               
              );
            }
            else if(type=='2x2'){   
                return (
                  <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                      
                              <Card hoverable onClick={() => buttonSelect(1,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option1 </b>
                              <CardBody>
                                  <b style={classes.ana}> {option1} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                      
                              <Card hoverable onClick={() => buttonSelect(2,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option2 </b>
                              <CardBody>
                                  <b style={classes.ana}> {option2} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                      
                              <Card hoverable onClick={() => buttonSelect(3,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option3 </b>
                              <CardBody>
                                  <b style={classes.ana}> {option3} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                          <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                      
                              <Card hoverable onClick={() => buttonSelect(4,quenum)}  sx={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                                  <b align="center"> Click to select option4 </b>
                              <CardBody>
                                  <b style={classes.ana}> {option4} </b>
                              </CardBody>
                              </Card>
                          </Link>
                      </GridItem>
                  </GridContainer>               
                  );
                }
        }

  

const submitPatternForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      var ans = que6+','+que7+','+que8+','+que9+','+que10+','+que11+','+que12+','+que13+','+que14+','+que15+','+que16+','+que17+','+que18+','+que19+','+que20+
          ','+que21+','+que22+','+que23+','+que24+','+que25+','+que26+','+que27+','+que28+','+que29+','+que30+
          ','+que31+','+que32+','+que33+','+que34+','+que35+','+que36

          var score=0;
          ///que1
          if(que6==='Option2'){
            score = score+2
          }
          if(que7=='Option1'){
            score = score+2
          }
          if(que8=='Option1'){
            score = score+2
          }///que2
          if(que9=='Option1'){
            score = score+1.5
          }
          if(que10=='Option2'){
            score = score+1.5
          }
          if(que11=='Option3'){
            score = score+1.5
          }
          if(que12=='Option1'){
            score = score+1.5
          }///que3
          if(que13==='Option1'){
            score = score+2
          }
          if(que14=='Option4'){
            score = score+2
          }
          if(que15=='Option1'){
            score = score+2
          }///que4
          if(que16==='Option3'){
            score = score+3
          }
          if(que17=='Option2'){
            score = score+3
          }
          ///que5
          if(que18==='Option2'){
            score = score+4.5
          }
          if(que19=='Option1'){
            score = score+4.5
          }///que6
          if(que20==='Option1'){
            score = score+3
          }
          if(que21=='Option1'){
            score = score+3
          }
          if(que22=='Option4'){
            score = score+3
          }///que7
          if(que23==='Option2'){
            score = score+3
          }
          if(que24=='Option1'){
            score = score+3
          }
          if(que25=='Option4'){
            score = score+3
          }///que8
          if(que26==='Option1'){
            score = score+4.5
          }
          if(que27=='Option3'){
            score = score+4.5
          }///que9
          if(que28==='Option1'){
            score = score+12
          }///que10
          if(que29==='Option2'){
            score = score+6
          }
          if(que30=='Option2'){
            score = score+6
          }///que11
          if(que31=='Option1'){
            score = score+3
          }
          if(que32=='Option1'){
            score = score+3
          }
          if(que33=='Option3'){
            score = score+3
          }
          if(que34=='Option3'){
            score = score+3
          }///que12
          if(que35==='Option3'){
            score = score+6
          }
          if(que36=='Option3'){
            score = score+6
          }

          console.log('score '+score)
          console.log(ans)
          seterror('')
          totaldata.preTest[0].bebras=ans
             
        const data=
        {
          preTest: totaldata.preTest
        }                    
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
        
    })
  
}


const submitAbstractionForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      var ans = self1+','+self2+','+self3+','+self4+','+self5+','+self6+','+self7+','+self8+','+self9+','+self10+
      ','+self11+','+self12+','+self13+','+self14+','+self15+','+self16+','+self17+','+self18

      console.log(ans)
      seterror('')
      totaldata.preTest[0].efficacy=ans
         
    const data=
    {
      preTest: totaldata.preTest
    }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  //}
}

const submitAlgorithmForm = () =>{
  const algo = myalgo;                     
  var empty = true;
  if(myalgo !== ''|| myalgo1 !== ''|| myalgo2 !== ''|| myalgo3 !== ''|| myalgo4 !== ''|| myalgo5 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter your text')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      if(mydata.abstraction[0].completed===false){
        mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
        mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
      
      }
      else{
        mydata.algorithm[0].userText='input,'+myalgo+';define,'+myalgo1+';set,'+myalgo2+',to,'+myalgo3+';output,'+myalgo4
        mydata.algorithm[0].userText1='set '+myalgo2+' to '+myalgo3
        
      }

      const data=
      {
        act:'activity1',
        algorithm:mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  }
}

const submitAnalysisForm = () =>{
  var empty = true;
  if(myspace !== '' && mytime !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter a number')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.analysis[0].spaceText=myspace
      mydata.analysis[0].timeText=mytime

      const data=
      {
        act:'activity1',
        analysis:mydata.analysis
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  }
}

const submitComparisonForm = () =>{
  var empty = true;
  if(mycomsol !== '' && mycomsol2 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter text above')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
            mydata.comparison[0].userText='Which of the solutions do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='You system can perform only maximum 5 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3

      const data=
      {
        act:'activity1',
        comparison:mydata.comparison
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity1[0]
        setmydata(activity)
    })
  }
}


const history = useNavigate();



//console.log(Num)
//console.log('Deco:'+mydeco)

const InputFeedback = ({ error }) =>
  error ? <div style={classNames("input-feedback")}>{error}</div> : null;

// Radio input
const RadioButton = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  ...props
}) => {
  return (
    <div>
      <input
        name={name}
        id={id}
        type="radio"
        value={id} // could be something else for output?
        checked={id === value}
        onChange={onChange}
        onBlur={onBlur}
        className={classNames("radio-button")}
        {...props}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

// Radio group
const RadioButtonGroup = ({
  value,
  error,
  touched,
  id,
  label,
  className,
  children
}) => {
  const classes = classNames(
    "input-field",
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched
    },
    className
  );

  return (
    <div className={classes}>
      <fieldset>
        <h5>{label}</h5>
        {children}
        {touched && <InputFeedback error={error} />}
      </fieldset>
    </div>
  );
};


    return(
    loading!==true?
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${clas._id}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>                                        
                <Typography color="textPrimary">Pre Test</Typography>
            </Breadcrumbs>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} >
            <Typography variant="h5" className="header-message" align="center">
              Test Questions 
            </Typography>
          </GridItem>
        </GridContainer>
        {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                    <GridContainer> 
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Thinking Panda' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <motion.div style={classes.modal1}>
                          <h5 style={classes.fontCursive}>Read the Instructions carefully.</h5>
                          <h5 style={classes.fontCursive}> Solve the problem to complete the activity and move forward in your mission.</h5>
                        </motion.div>
                      </GridItem>
                    </GridContainer>
                    <Button color="success" variant="contained" onClick={closeModal} 
                    title="Click here to  proceed" style={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}

                  <Formik                  
                    initialValues={{
                    gender: gender,
                    implement:implement,
                    que6:que6,
                    que7:que7,
                    que8:que8,
                    que9:que9,
                    que10:que10,
                    que11:que11,
                    que12:que12,
                    que13:que13,
                    que14:que14,
                    que15:que15,
                    que16:que16,
                    que17:que17,
                    que18:que18,
                    que19:que19,
                    que20:que20,
                    que21:que21,
                    que22:que22,
                    que23:que23,
                    que24:que24,
                    que25:que25,
                    que26:que26,
                    que27:que27,
                    que28:que28,
                    que29:que29,
                    que30:que30,
                    que31:que31,
                    que32:que32,
                    que33:que33,
                    que34:que34,
                    que35:que35,
                    que36:que36,
                    }}

                    onSubmit={(values, {setSubmitting}) => {
                      setTimeout(() => {
                      setSubmitting(false);
                      alert(JSON.stringify('Saving...', null, 2));
                                            
                      var ans = que1+','+selectedDate+','+values.gender+','+que2+','+que+','+values.implement+','+que3+','+que4+','+que5

                      console.log(ans)
                        seterror('')
                       totaldata.preTest[0].initial=ans

                        const data=
                        {
                          preTest: totaldata.preTest
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity1[0]
                          setmydata(activity)
                      })
                     }, 500);
                    }}
                >

       

          {({submitForm, values, isSubmitting, touched, errors}) => (
          // <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Form>
          {loading!==true?

            <GridContainer>
             
                {/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}

        

    {hintsActivity1.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                     
                      <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <GridContainer>
                          <motion.div style={classes.modal1}>
                            <h5 style={ansType.includes('Correct Answer')==true?{color:'green'}:{color:'red'}}> {ansType} </h5>
                            <Typography variant="subtitle1">  {altHint} </Typography>
                            <h5 style={classes.fontMonaco}> Current Step: {hintsActivity1[index].step} </h5>
                            <h5 style={classes.fontGaramond}> Your Task: {task[activeStep]}</h5>
                          </motion.div>
                        </GridContainer>
                          
                      </GridItem>
                         
                    </GridContainer>
                          <Button color="success" variant="contained" onClick={closeModalTwo} 
                            title="Click here to  proceed" style={{ fontSize: '10px' }} >
                              OK
                          </Button>
                    </motion.div>
                     
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal2}
                    variants={modal} 
                    >
                      <GridContainer>
                        {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='Marine Life' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9}>
                          <motion.div style={classes.modal2}>
                            <h4 style={classes.fontGaramond}> Are you sure you want to submit </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" style={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" style={{ fontSize: '10px' }} >
                                No
                            </Button>
                          </motion.div>
                        </GridItem>
                      </GridContainer>
                    
                    </motion.div>  
                </motion.div>
              </AnimatePresence>)}
            <GridItem xs={12} sm={12} md={12}>
              
                <GridContainer>

                  <GridItem xs={12} sm={12} md={12}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {steps.map((step, index) => {
                    return (
                      <Step key={index}>
                        <StepLabel><h5 style={classes.fontLucida}>{step}</h5></StepLabel>
                      </Step>
                      );
                      })}
                    </Stepper>
                  </GridItem>
                
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                    <h5 style={{...classes.fontCourier}}><b>Important Instructions:</b> Read the questions carefully and enter your answers accordingly</h5>
                      {activeStep=='0' ?   //////Decomposition
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            <Card>
                              <CardHeader color="success">
                              <h5 style={classes.cardTitleWhite}> {task[0]} </h5>
                              </CardHeader>
                              <b>{error!=''?'error: '+error:''}</b>
                                
                              <CardBody>
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={3}>
                                  <h5>1. Name:   <Field
                                                    component={TextField}
                                                    type="text"
                                                    //label="Enter name"
                                                    name="name"
                                                    value={que1}
                                                    placeholder='Enter name'
                                                    onChange={handleQue1Change} 
                                                  />
                                                  </h5> 
                                </GridItem> 
                                <GridItem xs={12} sm={12} md={3}>
                                   <h5>2. Date of Birth:  
                                    <DatePicker value={selectedDate} 
                                    onChange={handleDateChange} 
                                    format="dd/MM/yyyy" // 
                                    slotProps={{ textField: { fullWidth: true } }} 
                                    minDate={new Date(1900, 0, 1)}
                                    maxDate={new Date(2100, 11, 31)}
                                    />
                                  </h5>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={2}>
                                  <h5>3. Gender: </h5>
                                      <RadioButtonGroup
                                        id="gender"
                                        //label="One of these please"
                                        value={values.gender}
                                        error={errors.gender}
                                        touched={touched.gender}
                                      >
                                        <Field
                                          component={RadioButton}
                                          name="gender"
                                          id="Male"
                                          label="Male"
                                        />
                                        <Field
                                          component={RadioButton}
                                          name="gender"
                                          id="Female"
                                          label="Female"
                                        />
                                      </RadioButtonGroup>
                                </GridItem>
                                {setgender(values.gender)}
                                 
                                  <GridItem xs={12} sm={12} md={2}>
                                    <h5>4. Standard/Class:  
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que2}
                                                onChange={handleQue2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'V',value:'V'},{label:'VI',value:'VI'},{label:'VII',value:'VII'},{label:'VIII',value:'VIII'},{label:'IX',value:'IX'},{label:'X',value:'X'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field></h5>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={2}>
                                    <h5>5. Section:  
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que}
                                                onChange={handleQueChange}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'A',value:'A'},{label:'B',value:'B'},{label:'C',value:'C'},{label:'D',value:'D'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field></h5>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={7}>   
                                      <h5>6. Have you learned/implemented any programming problem previously?</h5>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={5}>
                                      <RadioButtonGroup
                                        id="implement"
                                        //label="One of these please"
                                        value={values.implement}
                                        error={errors.implement}
                                        touched={touched.implement}
                                      >
                                        <Field
                                          component={RadioButton}
                                          name="implement"
                                          id="Yes"
                                          label="Yes"
                                        />
                                        <Field
                                          component={RadioButton}
                                          name="implement"
                                          id="No"
                                          label="No"
                                        />
                                      </RadioButtonGroup>
                                    </GridItem>
                                  {setimplement(values.implement)}

                                  <GridItem xs={12} sm={12} md={12}>
                                  <h5>7. Do you know any programming language if yes which one (Enter 'No' if you don't know)?: 
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    //label="Enter name"
                                                    name="name"
                                                    value={que3}
                                                    placeholder='Enter name of language'
                                                    onChange={handleQue3Change}
                                                    //validate={validateSimName}
                                                    // {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                    //fullWidth= {true} 
                                                    />
                                  </h5>
                                  <h5>8. Last two previous mathematics exam score (enter percentage(%) out of 100)?
                                                
                                                 <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="score1"
                                                  //label="1st num"
                                                  value={que4}
                                                  onChange={handleQue4Change}
                                                  select
                                                  variant="standard"
                                                  helperText="score1"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numberList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label=""
                                                  value=","
                                                  //disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:',',value:','}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="score1"
                                                  //label="1st num"
                                                  value={que5}
                                                  onChange={handleQue5Change}
                                                  select
                                                  variant="standard"
                                                  helperText="score2"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numberList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                  </h5>
                                  {InitialForm()}
                                </GridItem>
                              </GridContainer>
                              </CardBody>
                            </Card>
                              {isSubmitting && <LinearProgress />}
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Save
                                </Button>
                              </GridItem> 
                            </GridItem>
                            
                        </GridContainer>
                      </GridItem>
                          :activeStep=='1' ?    ///Computational Thinking Test
                                        
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                          <h5 style={classes.fontCourier}><b> About the Test: </b> The test is used to assess the computational thinking skills of the user. Every question has a particular story with single/multiple subquestions. 
                          The subquestions are of multiple choice type with single correct answer. Read each question and answer all subquestions to move to the final step. Click on the card to select the answer.</h5>
                            <GridContainer>  
                                <b>{error!=''?'error: '+error:''}</b>    
                                <GridItem xs={12} sm={12} md={12}>
                                <Accordion expanded={expanded1 === 'panel1'} onChange={handleAccordionChange1('panel1')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>1. Beaver tournament </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails>
                                  <Card>
                                    <CardHeader color="success">
                                      <h4 style={classes.cardTitleWhite}>{task[1]}</h4>
                                      <h4>1. Beaver tournament</h4>
                                    </CardHeader>
                                    <p><i>{ansType}</i></p>
                                      
                                    <CardBody>
                                      <GridContainer>
        {/*....................................... Question1 .....................................*/}
                                        <GridItem xs={12} sm={12} md={7}>   
                                          
                                          <p> Beaver Kreso watched a tournament of races and recorded the winners of each stage on the board below.
                                            <div>
                                              The runners wore the same numbers, from 1 to 8, throughout the tournament. Kreso used numbered cards to represent each runner. 
                                            </div>
                                            When the tournament was over his younger brother Tomo mixed up all the cards, except those from all the first stage of the tournament.
                                          </p>
                                          <h5>Answer below questions following the picture on the right</h5>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                          <img alt='bebimage11' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/bebimg11.PNG'} />
                                          <p>Picture of tournament with only correct cards at first stage and extra cards at right</p>
                                          <br/> 
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q1.1. How to choose the cards of the tournament from second stage?</h5>
                                          {MCQAnswers('row', 6,{que6},'Select card randomly','Select card from the pair of cards at first stage and check if it is present in the stack at the right side.',
                                            'Select card from the pair of cards at first stage without checking if it is present in the stack at the right side',
                                            'Select card directly from stack of cards at right side without checking cards at first stage.' )}
                                       
                                        </GridItem> 
                                        <GridItem xs={12} sm={12} md={12}>
                                              <h5>Q1.2. Complete the below algorithm to select missing cards:</h5>
                                              <b>Step1: Define Current stage to second stage</b>
                                              <div><b>Step2: Select first missing card on current stage</b></div>
                                              Select among below options:
                                              {MCQAnswers('2x2', 7,{que7},
                                                <img alt='bebimage50' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg50.PNG'} />,
                                                <img alt='bebimage51' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg51.PNG'} />,
                                                <img alt='bebimage52' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg52.PNG'} />,
                                                  'None of the above' )}
                                        </GridItem>                              
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q1.3. Complete the tournament by putting labels. Select one of the correct options:</h5>
                                          Select among below options:
                                          {MCQAnswers('row', 8,{que8},
                                          <img alt='bebimage12' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg12.PNG'} />
                                          ,<img alt='bebimage13' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg13.PNG'} />
                                          ,<img alt='bebimage14' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg14.PNG'} />
                                          ,<img alt='bebimage15' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg15.PNG'} />
                                          )}
                                      </GridItem>
                                      
                                      
                                    </GridContainer>
                                  </CardBody>
                                </Card> 
                                </AccordionDetails>
                              </Accordion> 
{/*............................................... Question2 .....................................*/}
                                  
                                  <Accordion expanded={expanded1 === 'panel2'} onChange={handleAccordionChange1('panel2')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>2. Animal Competition </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails>    
                                <Card>
                                  <CardHeader color="success">
                                    <h4>2. Animal competition</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer> 
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage16' className="card-img-top" src={baseUrl+'assets/images/bebimg16.PNG'} />
                                          <h5>Answer the questions in the right hand side and below:</h5>
                                          <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q2.1. Observe the scores and identify the scores where the animals tied?</h5>
                                          {MCQAnswers('2x2', 9,{que9},'2,5','2,3','3,5','4' )}
                                              
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q2.2. Analyse the tied scores and identify the score given to animal</h5>
                                          {MCQAnswers('row', 10,{que10},'2=dog,2=beaver,5=dog,5=beaver',
                                          '2=dog,2=dog,5=dog,5=beaver','2=beaver,2=dog,5=dog,5=beaver',
                                          '2=beaver,2=beaver,5=beaver,5=dog' )}
                                          <h5>Q2.3.  Observe the scores given to dogs and beavers in the competition</h5>
                                          {MCQAnswers('row', 11,{que11},'Dogs=1,3,4,5---beaver=2,6,7',
                                          'Dogs=1,2,2,3,6---beaver=4,5,7','Dogs=1,2,2,3,4,5---beaver=5,6,7',
                                          'Dogs=3,4,5---beaver=1,2,2,5,6,7' )}
                                          <h5>Q2.4. Count the dogs that took part in the competition</h5>
                                          {MCQAnswers('row', 12,{que12},'6','7','4','5' )}
                                      </GridItem>     
                                    </GridContainer>
                                  </CardBody> 
                                </Card>
                                </AccordionDetails>
                                </Accordion>                                                                           
{/*............................................... Question3 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel3'} onChange={handleAccordionChange1('panel3')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>3. Beaver Code </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>3. Beaver Code</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>   
                                            <img alt='bebimage17' className="card-img-top" src={baseUrl+'assets/images/bebimg17.PNG'} />
                                            <h5>Identify the names of her friends Abby, Arya, Barry, Ray. 
                                              Answer the questions in the right hand side and below:</h5>
                                              <br />
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={12}>
                                           
                                              
                                          </GridItem>
                                        </GridContainer>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                              <h5>Q3.1. Identify the codes of first letter of four names of friend</h5>
                                              {MCQAnswers('col', 13,{que13},'ABBY(A)- two sun; ARYA(A)- two sun; BARRY(B)-flower; RAY(R)- sun, flower, sun',
                                              'ABBY(A)- two sun; ARYA(A)- two sun; BARRY(B)-flower, sun; RAY(R)- sun, flower',
                                              'ABBY(A)- two flower; ARYA(A)- two flower; BARRY(B)-sun; RAY(R)- sun, flower',
                                              'ABBY(A)- flower; ARYA(A)- flower; BARRY(B)-flower, sun; RAY(R)- flower' )}
                                            
                                          </GridItem>  
                                        </GridContainer>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q3.2. Observe the letter codes and identify the total code of Abby:</h5>
                                              {MCQAnswers('row', 14,{que14},
                                              <img alt='bebimage53' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg53.PNG'} />
                                              ,<img alt='bebimage54' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg54.PNG'} />
                                              ,<img alt='bebimage55' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg55.PNG'} />
                                              ,<img alt='bebimage56' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg56.PNG'} />
                                              )}
                                      <h5>Q3.3. Select the correct match of flowers with the names of Barbara’s friends: </h5>
                                            {MCQAnswers('2x2', 15, {que15},
                                            <img alt='bebimage19' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg19.PNG'} />
                                            ,<img alt='bebimage20' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg20.PNG'} />
                                            ,<img alt='bebimage21' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg21.PNG'} />
                                            ,'None of the above'
                                            )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question4 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>4. Jersey Numbers </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>4. Jersey Numbers</h4>
                                  </CardHeader>                
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage22' className="card-img-top" src={baseUrl+'assets/images/bebimg22.PNG'} />
                                          <h5>. 
                                            Answer the questions in the right hand side:</h5>
                                            <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q4.1. Select the ordering of team2 by jersey numbers:</h5>
                                          {MCQAnswers('2x2', 16,{que16},'2,6,8,11,12,13,14,16,19,23,24,27,28,29',
                                          '2,29,28,27,24,23,19,16,14,13,12,11,8,6,3',
                                          '2,3,6,8,11,12,13,14,16,19,23,24,27,28,29',
                                          '2,3,6,8,11,23,24,27,28,29,12,13,14,16,19' )}
                                          <h5>Q4.2. How many jersey numbers are used in team 1 that area used in team 2:</h5>
                                          {MCQAnswers('row', 17,{que17},'3','2','4','1' )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                              </Accordion> 
{/*............................................... Question5 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel5'} onChange={handleAccordionChange1('panel5')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>5. Passcode </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>5. Passcode</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <h4>5. Passcode</h4>
                                          <img alt='bebimage23' className="card-img-top" src={baseUrl+'assets/images/bebimg23.PNG'} />
                                          <h5>. 
                                            Answer the questions in the right hand side and below to determine the passcode:</h5>
                                            <br />
                                            <h5>Q5.2. Select the correct passcode:</h5>
                                          {MCQAnswers('2x2', 19,{que19},'726292627','962676269','269727962','762696267' )}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q5.1. Select the correct option related to numbers in passcode:</h5>
                                          {MCQAnswers('col', 18,{que18},'highest value: 7, Lowest value: 2, odd digits: 9',
                                          'highest value: 9, Lowest value: 2, odd digits: 7,9'
                                          ,'highest value: 9, Lowest value: 6, odd digits: 7','None of the above' )}
                                      </GridItem>  
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                              </AccordionDetails>
                            </Accordion>
{/*............................................... Question6 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>6. Brackets </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>6. Brackets</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage24' className="card-img-top" src={baseUrl+'assets/images/bebimg24.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the questions in the right hand side and below:</h5>
                                            <br />
                                          
                                          
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <img alt='bebimage25' className="card-img-top" src={baseUrl+'assets/images/bebimg25.PNG'} />
                                          {MCQAnswers('col', 20,{que20},
                                          <img alt='bebimage26' className="card-img-top" src={baseUrl+'assets/images/bebimg26.PNG'} />
                                          ,<img alt='bebimage27' className="card-img-top" src={baseUrl+'assets/images/bebimg27.PNG'} />
                                          ,<img alt='bebimage28' className="card-img-top" src={baseUrl+'assets/images/bebimg28.PNG'} />
                                          ,'None of the above'
                                           )}
                                          
                                      </GridItem> 
                                      <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q6.2. Complete the below algorithm to identify bracket created with above method:</h5>
                                            <b>Step1: Start from the extreme left bracket and check the type</b>
                                            <div>
                                              Select among below options:
                                            </div>
                                          {MCQAnswers('2x2', 21,{que21},
                                                <img alt='bebimage57' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg57.PNG'} />,
                                                <img alt='bebimage58' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg58.PNG'} />,
                                                <img alt='bebimage59' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg59.PNG'} />,
                                                <img alt='bebimage60' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg60.PNG'} /> 
                                                  )}
                                      <h5>Q6.3. Which of the following bracelets is made with the methods descibed above:</h5>
                                          {MCQAnswers('2x2', 22,{que22},
                                          <img alt='bebimage29' className="card-img-top" src={baseUrl+'assets/images/bebimg29.PNG'} />
                                          ,<img alt='bebimage30' className="card-img-top" src={baseUrl+'assets/images/bebimg30.PNG'} />
                                          ,<img alt='bebimage31' className="card-img-top" src={baseUrl+'assets/images/bebimg31.PNG'} />
                                          ,<img alt='bebimage32' className="card-img-top" src={baseUrl+'assets/images/bebimg32.PNG'} />
                                           )}
                                      </GridItem>
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                              </AccordionDetails>
                            </Accordion>
{/*............................................... Question7 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>7. Balls </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>7. Balls</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage33' className="card-img-top" src={baseUrl+'assets/images/bebimg33.PNG'} />
                                          <h5> 
                                            With the information and question given above, Answer the questions in the right hand side and below to identify the final result:</h5>
                                           
                                            <br /> 
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q7.1. Find the order of the balls in the holes A,B, and C from top to bottom:</h5>
                                          {MCQAnswers('2x2', 23,{que23},'A-1, 2, 3; B-5, 4; C-6','A-3, 2, 1; B-5, 4; C-6',
                                          'A-3, 2, 1; B-4, 5; C-6','A-1, 2, 3; B-4, 5; C-6' )} 
                                         
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>

                                          <h5>Q7.2. Complete the below algorithm to identify order of balls:</h5>
                                              Select among below options:
                                              {MCQAnswers('2x2', 24,{que24},
                                                <img alt='bebimage61' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg61.PNG'} />,
                                                <img alt='bebimage62' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg62.PNG'} />,
                                                <img alt='bebimage63' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg63.PNG'} />,
                                                'None of the above' 
                                                  )}
                                          <h5>Q7.3. Select the final result after the pins A, B and C are pulled down:</h5>
                                                {MCQAnswers('2x2', 25,{que25},
                                                <img alt='bebimage34' className="card-img-top" src={baseUrl+'assets/images/bebimg34.PNG'} />
                                                ,<img alt='bebimage35' className="card-img-top" src={baseUrl+'assets/images/bebimg35.PNG'} />
                                                ,<img alt='bebimage36' className="card-img-top" src={baseUrl+'assets/images/bebimg36.PNG'} />
                                                ,<img alt='bebimage37' className="card-img-top" src={baseUrl+'assets/images/bebimg37.PNG'} />
                                                )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question8 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel8'} onChange={handleAccordionChange1('panel8')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>8. Blossom </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>8. Blossom</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage38' className="card-img-top" src={baseUrl+'assets/images/bebimg38.PNG'} />
                                          <h5> 
                                            With the information and question given above, Answer the questions in the right hand side and below to identify the final result:</h5>
                                           
                                            <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q8.1. Identify the flower which didn’t blossom after 2 attempts of Jane (Numbering from Left):</h5>
                                          {MCQAnswers('2x2', 26,{que26},'2nd and 4th flower','1st and 3rd flower',
                                          '3rd and 5th flower','2nd flower' )}
                                          

                                          <h5>Q8.2. Follow the flowers that didn’t blossom and identify the colors left. Which colours did the computer choose for the flowers?:</h5>
                                          {MCQAnswers('2x2', 27,{que27},'blue pink blue orange orange','pink blue blue blue orange',
                                          'pink blue blue pink orange','pink pink blue pink orange' )}
                                                
                                      
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                              </Accordion> 
{/*............................................... Question9 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>9. Medical Lab </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                  <h4>9. Medical Lab</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage39' className="card-img-top" src={baseUrl+'assets/images/bebimg39.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side and below to identify the final result:</h5>   
                                            <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q9.1. How many times will the device shake the specimens when the program will run?</h5>
                                          {MCQAnswers('2x2', 28,{que28},'The specimens will never be shaken','The specimens will be shaken once',
                                          'The specimens will be shaken 60 times','None of the above' )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question10 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel10'} onChange={handleAccordionChange1('panel10')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>10. Secret messages </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>10. Secret messages</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage40' className="card-img-top" src={baseUrl+'assets/images/bebimg40.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side:</h5>
                                            <br />
                                          <h5>Q10.2. Follow the above 4 column secret message. What message does Bertha send back?</h5>
                                          {MCQAnswers('2x2', 30,{que30},'OKWHERETOMEET!','OKIWILLBETHERE!','WILLYOUBETHERETOO!','OKIWILLMEETHIM!' )} 
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q10.1. Select the 4 column grid of the secret message ‘OIERKLTEILH!WBEX’ that Bertha replied to Boris:</h5>
                                                {MCQAnswers('col', 29,{que29},
                                                <img alt='bebimage41' className="card-img-top" src={baseUrl+'assets/images/bebimg41.PNG'} />
                                                ,<img alt='bebimage42' className="card-img-top" src={baseUrl+'assets/images/bebimg42.PNG'} />
                                                ,<img alt='bebimage43' className="card-img-top" src={baseUrl+'assets/images/bebimg43.PNG'} />
                                                ,'None of the above'
                                                )}  
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question11 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel11'} onChange={handleAccordionChange1('panel11')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>11. Stack Computer </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>11. Stack Computer</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage44' className="card-img-top" src={baseUrl+'assets/images/bebimg44.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side and below:</h5>
                                            <br />
                                          
                                   
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                            <h5>Q11.1. Identify the order in which the operations are calculated for equations 4*(8+3)-2 from left:</h5>
                                              {MCQAnswers('2x2', 31,{que31},'*,+,-','-,+,*','+,*,-','None of the above' )} 
                                            
                                            
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q11.2. Select the computation of a*(b+c) in the stack computer:</h5>
                                              {MCQAnswers('row', 32,{que32},'abc+*','abc*+','cba+*','bca*+' )} 
                                          <h5>Q11.3. Complete the below algorithm to calculate the computation in stack computer:</h5>
                                              <b>Step1: Start from Left, find first operator (*/-/+)</b>
                                              <p>Select among below options:</p>
                                              {MCQAnswers('2x2', 33,{que33},
                                                <img alt='bebimage64' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg64.PNG'} />,
                                                <img alt='bebimage65' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg65.PNG'} />,
                                                <img alt='bebimage66' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg66.PNG'} />,
                                                'None of the above' 
                                              )}
                                          <h5>Q11.4. How should the following computation-4*(8+3)-2 be entered:</h5>
                                              {MCQAnswers('row', 34,{que34},'483+-2*','483+2*-','483+*2-','48+3*2-' )} 
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question12 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>12. Throw the Dice </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>12. Throw the Dice</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>      
                                          <img alt='bebimage45' className="card-img-top" src={baseUrl+'assets/images/bebimg45.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side:</h5>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                      <h5>Q12.1. Analyse the above algorithm and select the options concerning three throws that will send the young beavers to the sports field:</h5>
                                                {MCQAnswers('2x2', 35,{que35},'First throw less than second throw, Third throw less than first throw"',
                                                'First throw greater than second throw, Third throw less than first throw',
                                                'First throw less than equal to second throw, Third throw greater than equal to first throw',
                                                'First throw greater than second throw, Third throw greater than first throw' )}
                                            
                                      </GridItem> 
                                      <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q12.2. Which sequence of throws will send the young beavers to the sports field?</h5>
                                                {MCQAnswers('2x2', 36,{que36},
                                                <img alt='bebimage46' className="card-img-top" src={baseUrl+'assets/images/bebimg46.PNG'} />
                                                ,<img alt='bebimage47' className="card-img-top" src={baseUrl+'assets/images/bebimg47.PNG'} />
                                                ,<img alt='bebimage48' className="card-img-top" src={baseUrl+'assets/images/bebimg48.PNG'} />
                                                ,<img alt='bebimage49' className="card-img-top" src={baseUrl+'assets/images/bebimg49.PNG'} />
                                                )}
                                      </GridItem>
                                      {BebrasForm()}
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
                                <b>{error!=''?'error: '+error:''}</b>
                                    {isSubmit && <LinearProgress />} 
                                    <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isSubmit}
                                            onClick={submitPatternForm}
                                          >
                                            Save
                                          </Button>
                                    </GridItem> 
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            
                        </GridContainer>
                      </GridItem>

                          :activeStep=='2' ? 

                          
                            <GridItem xs={12} sm={12} md={12}>
                              <GridContainer>      
                                <h5 style={classes.fontCourier}><b> About the Test: </b> The test is used to assess the computational thinking self efficacy skills of the user. 
                                Below are some statements in which you may agree or disagree. Using the options given 
                                please indicate the extent of your agreement by marking the corresponding response for each statement.</h5>
                                <h5> Please make sure that you answer every item. There are no right or wrong answers.</h5>
                              <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                  <CardHeader color="success">
                                    <h4 style={classes.cardTitleWhite}> {task[2]}</h4>
                                  </CardHeader>
                                  <p><i>{ansType}</i></p>
                                  <b> {error!=''?'error: '+error:''}</b>
                                <CardBody>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h4>Statements related to your ability to perform tasks</h4>   
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Choose answers among </h5>
                                      <h5>Strongly Agree/Agree/Neutral/Disagree/Strongly disagree</h5> 
                                  </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="1. I distinguish repeating structures within data or images."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'1. I distinguish repeating structures within data or images.',value:'1. I distinguish repeating structures within data or images.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self1}
                                                onChange={handleSelf1Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="2. I evaluate the steps necessary to solve the problem from different angles. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'2. I evaluate the steps necessary to solve the problem from different angles. ',value:'2. I evaluate the steps necessary to solve the problem from different angles. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self2}
                                                onChange={handleSelf2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="3. I run multiple tasks at the same time to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'3. I run multiple tasks at the same time to solve the problem. ',value:'3. I run multiple tasks at the same time to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self3}
                                                onChange={handleSelf3Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. ',value:'4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self4}
                                                onChange={handleSelf4Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="5. I examine the data I have collected to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'5. I examine the data I have collected to solve the problem. ',value:'5. I examine the data I have collected to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self5}
                                                onChange={handleSelf5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="6. I relate problems to real life. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'6. I relate problems to real life. ',value:'6. I relate problems to real life. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self6}
                                                onChange={handleSelf6Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="7. I separate the data by type (text, number, series, etc.). "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'7. I separate the data by type (text, number, series, etc.). ',value:'7. I separate the data by type (text, number, series, etc.). '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self7}
                                                onChange={handleSelf7Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="8. I understand whether the problem is composed of sub-problems. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'8. I understand whether the problem is composed of sub-problems. ',value:'8. I understand whether the problem is composed of sub-problems. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self8}
                                                onChange={handleSelf8Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="9. I decide whether the data to be used to solve the problem is sufficient or not. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'9. I decide whether the data to be used to solve the problem is sufficient or not. ',value:'9. I decide whether the data to be used to solve the problem is sufficient or not. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self9}
                                                onChange={handleSelf9Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="10. I comment on the data I used to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'10. I comment on the data I used to solve the problem. ',value:'10. I comment on the data I used to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self10}
                                                onChange={handleSelf10Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="11. I connect the problem I have encountered with the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'11. I connect the problem I have encountered with the problems I have encountered before. ',value:'11. I connect the problem I have encountered with the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self11}
                                                onChange={handleSelf11Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="12. If the problem has sub-problems, I manage the solution processes of these sub-problems. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'12. If the problem has sub-problems, I manage the solution processes of these sub-problems. ',value:'12. If the problem has sub-problems, I manage the solution processes of these sub-problems. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self12}
                                                onChange={handleSelf12Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="13. I find the fastest solution that works correctly through different process steps. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'13. I find the fastest solution that works correctly through different process steps. ',value:'13. I find the fastest solution that works correctly through different process steps. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self13}
                                                onChange={handleSelf13Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="14. I can understand how a problem I have encountered differs from the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'14. I can understand how a problem I have encountered differs from the problems I have encountered before. ',value:'14. I can understand how a problem I have encountered differs from the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self14}
                                                onChange={handleSelf14Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="15. I organize the data I collect in a way that is more understandable for the solution of the problem."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'15. I organize the data I collect in a way that is more understandable for the solution of the problem.',value:'15. I organize the data I collect in a way that is more understandable for the solution of the problem.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self15}
                                                onChange={handleSelf15Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="16. I decide whether the problem solution I chose is fit for purpose. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'16. I decide whether the problem solution I chose is fit for purpose. ',value:'16. I decide whether the problem solution I chose is fit for purpose. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self16}
                                                onChange={handleSelf16Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="17. If the problem has sub-problems, I divide it into smaller sub-problems."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'17. If the problem has sub-problems, I divide it into smaller sub-problems.',value:'17. If the problem has sub-problems, I divide it into smaller sub-problems.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self17}
                                                onChange={handleSelf17Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="18. I develop different solution proposals for the solution of a problem."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'18. I develop different solution proposals for the solution of a problem.',value:'18. I develop different solution proposals for the solution of a problem.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self18}
                                                onChange={handleSelf18Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              {EfficacyForm()}
                                    </GridItem>
                                    
                                    <b>{error!=''?'error: '+error:''}</b>
                                </GridContainer>
                                </CardBody>
                                {isSubmit && <LinearProgress />}
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmit}
                                    onClick={submitAbstractionForm}
                                  >
                                    Save
                                  </Button>
                                </GridItem> 
                              </GridItem>
                                
                                
                              </GridContainer>
                            </GridItem>                           
                           
                          :null}

                      </GridContainer>
                      {loading!==true?
                      <GridContainer>
                            <GridItem xs={12} sm={12} md={9}>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                            {isSubmit && <LinearProgress />}
                              <div>
                                {activeStep === steps.length-1 ?(
                                <div>
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                    </Button>
                                  
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      disabled={isSubmit}
                                      onClick={handleNext}
                                    >
                                      Submit Final 
                                    </Button>
                                </div>):
                                (
                                  <div>
                                    <div>
                                      <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      <Button variant="contained" 
                                        disabled={isSubmit}
                                        color="primary" 
                                        onClick={handleNext}>
                                        Submit and Go to Next Step
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </GridItem>
                      </GridContainer>:null}
                  </GridItem>

                  </GridContainer>
                </GridItem>
            </GridContainer>:null}
                                                                      

          </Form>
          //</LocalizationProvider>
          )}
          
          </Formik>
         

    </LocalizationProvider>:<GridContainer spacing={2}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={640} height={400} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={640} height={400} />    
          </Box> 
          </GridItem>
        <GridItem xs={12} sm={12} md={12}>         
          <Skeleton variant="text" />
        </GridItem>
      </GridContainer>
    );
}

